const agreements = [
  'resident_patient',
  'legal_representative',
  'confidence_person'
]

export default agreements